const routes = [
  {
    path: '/agrupados-por-forma-pago',
    name: 'Forma Pago',
    component: () => import('@/views/reportes/AgrupadosFormaPago.vue'),
    meta: { title: 'Agrupados por Forma de Pago' }
  },
  {
    path: '/agrupados-por-asegurador',
    name: 'Pagos Asegurador',
    component: () => import('@/views/reportes/AgrupadosAsegurador.vue'),
    meta: { title: 'Agrupados por Asegurador' }
  },
  {
    path: '/agrupados-estado-factura',
    name: 'Estado Factura',
    component: () => import('@/views/reportes/AgrupadosEstadoFactura.vue'),
    meta: { title: 'Agrupados por Estado de Factura' }
  },
/*  
  {
    path: '/pagos-agrupados-por-tipo',
    name: 'Pagos por Tipo',
    component: () => import('@/views/reportes/PagosAgrupadosPorTipo.vue'),
    meta: { title: 'Pagos Agrupados por Tipo' }
  },
*/
];

export { routes };